// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"25":"12a5becd","161":"3ce82412","472":"2bd21967","480":"82ab81aa","518":"a97a39c6"}[chunkId] + ".js";
};